module.exports = __webpack_public_path__ + "img/25_1.e2a19cb1.png";